import { Router } from '@angular/router';
import {
  BaseComponent,
} from '@moduurnv2/libs-orderingapp/src/core';

export class ComboBaseComponent extends BaseComponent {

}
